import { Component, OnDestroy } from '@angular/core';
import { LanguageService } from '@spartacus/core';
import { map, Observable, Subscription } from 'rxjs';
import { GetDocumentService } from 'src/app/customServices/get-document.service';

@Component({
  selector: 'app-warranty-paragraph',
  templateUrl: './warranty-paragraph.component.html',
  styleUrl: './warranty-paragraph.component.scss',
  standalone: false
})
export class WarrantyParagraphComponent implements OnDestroy {

  activeLanguage!: string;
  latestDocUrl$: Observable<string>;
  subscription = new Subscription();
  constructor(private documentService: GetDocumentService,
    private languageService: LanguageService
  ) {

  }
  ngOnInit() {
    this.subscription.add(this.languageService.getActive().subscribe((lan) => {
      this.activeLanguage = lan;
    }));
    this.latestDocUrl$ = this.documentService.getDocumentByDocumentCode('Y483080').pipe(
      map((response: { url: string }) => response.url)
    );
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();

  }

}
